import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import React from 'react';
import { EmeraldInputCoreInputs, EmeraldInputType } from '@emerald/nxcore';
import { EmeraldIcon } from '@emerald-react/icon';
import { useDefaultProps } from '@emerald-react/core';

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var cn = classnames.exports;

class EmeraldLabelInputs extends EmeraldInputCoreInputs {}

const EmeraldLabel = /*#__PURE__*/React.memo(inputs => {
  const props = useDefaultProps(inputs, new EmeraldLabelInputs());
  const FilledLabel = () => jsxs(Fragment, {
    children: [jsx("span", {
      className: "mdc-text-field__ripple"
    }), jsx("span", {
      className: cn('mdc-floating-label', {
        'mdc-floating-label--float-above': props.floatLabel
      }),
      id: props.id,
      children: props.label
    })]
  });
  const OutLinedLabel = () => jsxs("span", {
    className: cn('mdc-notched-outline', {
      'mdc-notched-outline--notched': props.floatLabel,
      'mdc-notched-outline--upgraded': props.floatLabel
    }),
    children: [jsx("span", {
      className: "mdc-notched-outline__leading"
    }), props.label && jsx("span", {
      className: "mdc-notched-outline__notch",
      children: jsx("span", {
        className: cn('mdc-floating-label', {
          'mdc-floating-label--float-above': props.floatLabel
        }),
        id: props.id,
        children: props.label
      })
    }), jsx("span", {
      className: "mdc-notched-outline__trailing"
    })]
  });
  const LabelTemplate = () => props.outlined ? OutLinedLabel() : FilledLabel();
  const CanHaveClearIcon = () => {
    const NoClearIconTypes = [EmeraldInputType.Color, EmeraldInputType.TextArea];
    return NoClearIconTypes.indexOf(props.type) < 0;
  };
  const CanHaveTrailingIcon = () => {
    const NoIconTypes = [EmeraldInputType.Color, EmeraldInputType.TextArea, EmeraldInputType.Number, EmeraldInputType.Week];
    return NoIconTypes.indexOf(props.type) < 0;
  };
  return jsxs(Fragment, {
    children: [jsxs("label", {
      className: cn('mdc-text-field', {
        'mdc-text-field--textarea': props.type === EmeraldInputType.TextArea,
        'mdc-text-field--filled': !props.outlined,
        'mdc-text-field--outlined': props.outlined,
        'mdc-text-field--with-leading-icon': props.leadingIcon,
        'mdc-text-field--with-trailing-icon': props.trailingIcon,
        'mdc-text-field--label-floating': props.isFocused || !!props.value || props.floatLabel,
        'mdc-text-field--focused': props.isFocused,
        'mdc-with-value': props.value,
        'classic-html-datetimepicker': props.type === EmeraldInputType.Date || props.type === EmeraldInputType.Month || props.type === EmeraldInputType.LocalTime || props.type === EmeraldInputType.Week || props.type === EmeraldInputType.Time,
        'mdc-no-label': !props.label,
        'mdc-text-field--no-label': !props.label
      }),
      children: [LabelTemplate(), props.leadingTemplate ? props.leadingTemplate : props.leadingIcon && props.type !== 'textarea' && jsx(EmeraldIcon, {
        classes: "mdc-text-field__icon mdc-text-field__icon--leading",
        tabIndex: 0,
        role: "button",
        onClick: props.onLeadingIconClick,
        icon: props === null || props === void 0 ? void 0 : props.leadingIcon
      }), props.prefixText && jsx("span", {
        className: "mdc-text-field__affix mdc-text-field__affix--prefix",
        children: props.prefixText
      }), props.children, jsxs("div", {
        className: "input-trailing-icons",
        children: [CanHaveClearIcon() && props.showClearIcon && jsx(EmeraldIcon, {
          classes: "input-clear-icon",
          role: "button",
          onClick: props.onClearIconClick,
          icon: 'close'
        }), props.trailingTemplate ? props.trailingTemplate : props.trailingIcon && CanHaveTrailingIcon() && jsx(EmeraldIcon, {
          classes: "mdc-text-field__icon mdc-text-field__icon--trailing",
          role: "button",
          onClick: props.onTrailingIconClick,
          icon: props === null || props === void 0 ? void 0 : props.trailingIcon
        })]
      }), props.suffixText && jsx("span", {
        className: "mdc-text-field__affix mdc-text-field__affix--suffix",
        children: props.suffixText
      }), !props.outlined && jsx("span", {
        className: "mdc-line-ripple"
      })]
    }), props.helperTemplate]
  });
});
EmeraldLabel.displayName = 'EmeraldLabel';

export { EmeraldLabel };
